var map = {
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/project/animals/bat.png": "d90f",
	"./template/project/animals/desktop.svg": "796f",
	"./template/project/animals/mobile.svg": "458d",
	"./template/project/animals/snake.png": "35f3",
	"./template/project/animals/tablet.svg": "e933",
	"./template/project/flu_comparison/desktop.svg": "3191",
	"./template/project/flu_comparison/mobile.svg": "3bda",
	"./template/project/flu_comparison/tablet.svg": "b7ed",
	"./template/project/intro-desktop.jpg": "4b12",
	"./template/project/intro.jpg": "f6ee",
	"./template/project/photo-1-desktop.jpg": "7a20",
	"./template/project/photo-1.jpg": "b920",
	"./template/project/photo-2-desktop.jpg": "fd5b",
	"./template/project/photo-2.jpg": "de60",
	"./template/project/photo-3-desktop.jpg": "928d",
	"./template/project/photo-3.jpg": "a75f",
	"./template/project/photo-4-desktop.jpg": "1ae3",
	"./template/project/photo-4.jpg": "85f8",
	"./template/project/sars_wuhan_comparison/desktop.svg": "19c1",
	"./template/project/sars_wuhan_comparison/mobile.svg": "e808",
	"./template/project/sars_wuhan_comparison/tablet.svg": "b7fd",
	"./template/project/surgical-mask/correct.jpg": "2fc3",
	"./template/project/surgical-mask/desktop.svg": "9c0b",
	"./template/project/surgical-mask/mobile.svg": "050b",
	"./template/project/surgical-mask/tablet.svg": "23c2",
	"./template/project/surgical-mask/wrong.jpg": "76c6",
	"./template/project/wuhan_zoomin-desktop.gif": "fdc4",
	"./template/project/wuhan_zoomin.gif": "857a",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";